import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[620px] md:h-[780px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20moody%20red%20carpet%20event%20scene%20with%20dramatic%20spotlight%20and%20silhouettes%20of%20celebrities%2C%20paparazzi%20camera%20flashes%2C%20luxurious%20atmosphere%20with%20deep%20shadows%2C%20cinematic%20noir%20style%2C%20dark%20velvet%20background%20with%20golden%20light%20streaks%2C%20mysterious%20and%20glamorous%20Hollywood%20vibe%2C%20high%20contrast%20editorial%20photography%2C%20elegant%20composition%20with%20empty%20red%20carpet%20leading%20into%20darkness%20with%20subtle%20bokeh%20lights%20in%20distance&width=1920&height=1080&seq=hero-bg-chigua-01&orientation=landscape"
        alt="爆料吃瓜 - 全网热点一手爆料"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="爆料吃瓜网 - 全网热点一手爆料每日更新"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-background-50"></div>

      <div className="relative z-10 w-full h-full flex flex-col justify-center px-4 md:px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="flex flex-col gap-1 md:gap-2">
            <h1 className="text-4xl md:text-5xl lg:text-7xl font-heading font-black text-foreground-50 tracking-wide leading-tight">
              全网热点
            </h1>
            <h2 className="text-5xl md:text-6xl lg:text-8xl font-heading font-black text-foreground-50 tracking-wide leading-tight">
              一手爆料
            </h2>
            <h3 className="text-6xl md:text-7xl lg:text-9xl font-heading font-black text-accent-400 tracking-wide leading-tight">
              每日更新
            </h3>
          </div>
        </div>

        <div className="mt-10 md:mt-14 flex flex-col lg:flex-row gap-6 lg:gap-20 max-w-4xl">
          <p className="text-base md:text-lg text-foreground-200/80 leading-relaxed max-w-md">
            实时追踪网红黑料大瓜每日更新<br />
            91爆料吃瓜官网入口同步更新
          </p>
          <p className="text-base md:text-lg text-foreground-200/80 leading-relaxed max-w-md lg:mt-4">
            覆盖明星八卦、网红黑料、综艺爆料<br />
            不错过任何吃瓜资源与独家爆料
          </p>
        </div>

        <div className="mt-10 md:mt-12 flex items-center gap-4">
          <Link
            to="/category/wanghong-heiliao"
            className="px-7 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-400 transition-colors duration-200 whitespace-nowrap"
          >
            立即吃瓜
          </Link>
          <Link
            to="/about"
            className="px-7 py-3 rounded-full border border-foreground-300/30 text-foreground-200 font-medium text-sm hover:border-foreground-300/60 hover:text-foreground-100 transition-all duration-200 whitespace-nowrap"
          >
            App下载
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-foreground-300/40 rounded-full flex justify-center pt-2">
          <div className="w-1 h-2 bg-foreground-300/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}